import { ReactElement, ReactNode } from "react";

import { View } from "./View";

interface IOffsetGridColumn {
  span?: number;
  offset?: number;
}

export interface ICdsColumnProps {
  sm?: number | IOffsetGridColumn;
  md?: number | IOffsetGridColumn;
  lg?: number | IOffsetGridColumn;
  className?: string;
  children: ReactElement | ReactNode;
}

export const CdsColumn = (props: ICdsColumnProps) => {
  return <View sm={props.sm} md={props.md} lg={props.lg} {...props} />;
};
